module.exports = __webpack_public_path__ + "638412935ffb8796ae49155fb28a1448.MP3";